import { ROUTES } from 'common/domain/routes';

function checkRoutes($injector, $location) {
  if (!$location || !$location.url()) {
    return $location.path(`${ROUTES.ROOT}`); // In mobile runtime $location.url() is not accessible: redirect to root
  }

  if ($location.url().includes(ROUTES.VACATIONS_ABSENCES.ROOT)) {
    return $location.path(`${ROUTES.VACATIONS_ABSENCES.ROOT}${ROUTES.VACATIONS_ABSENCES.MY_VACATIONS}`);
  }

  if ($location.url().includes(ROUTES.FOOD_BENEFIT.ROOT)) {
    return $location.path(`${ROUTES.FOOD_BENEFIT.ROOT}${ROUTES.FOOD_BENEFIT.MY_FOOD_BENEFIT}`);
  }

  if ($location.url().includes(ROUTES.LOANS.ROOT)) {
    return $location.path(`${ROUTES.LOANS.ROOT}${ROUTES.LOANS.CREDITWORTHINESS}`);
  }

  if ($location.url().includes(ROUTES.SOLIDARITY.ROOT)) {
    return $location.path(`${ROUTES.SOLIDARITY.ROOT}${ROUTES.SOLIDARITY.MY_SOLIDARITY}`);
  }

  if ($location.url().includes(ROUTES.SOCIAL_SECURITY)) {
    return $location.path(`${ROUTES.SOCIAL_SECURITY}`);
  }

  if ($location.url().includes(ROUTES.NOT_ALLOWED)) {
    return $location.path(`${ROUTES.NOT_ALLOWED}`);
  }

  return $location.path(`${ROUTES.INDEX}`);
}

export { checkRoutes };



// WEBPACK FOOTER //
// ./client/app/features/mainRouting/checkRoutes.helper.js